import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    readonly: { type: Boolean, default: false },
    score: { type: Number, default: 0 },
    scoreName: String,
    single: { type: Boolean, default: false },
  };

  connect() {
    if (this.readonlyValue) this.element.classList.add('rating--readonly');

    this.#buildIcons();
    this.#paint(this.scoreValue);

    if (this.scoreNameValue) this.#buildScoreField();
  }

  cancel() {
    const value = this.scoreValue;

    this.reset(0);
    this.dispatch('cancel', { detail: { value } });
  }

  reset(value) {
    this.scoreValue = value;
    this.element.dataset.score = value || '';

    this.#paint(value);

    if (this.scoreField) this.scoreField.value = value || '';
  }

  #active(position, value) {
    return this.singleValue ? position === value : position <= value;
  }

  #buildIcons() {
    this.icons = Array.from(this.element.querySelectorAll('[data-rating-icon]'));

    if (!this.readonlyValue) {
      this.element.addEventListener('click', (event) => this.#onClick(event));
      this.element.addEventListener('mouseover', (event) => this.#onHover(event));
      this.element.addEventListener('mouseleave', () => this.#paint(this.scoreValue));
    }
  }

  #buildScoreField() {
    this.scoreField = document.createElement('input');

    this.scoreField.type = 'hidden';
    this.scoreField.name = this.scoreNameValue;
    this.scoreField.value = this.scoreValue || '';

    this.element.appendChild(this.scoreField);
  }

  #hover(value) {
    this.icons.forEach((item) => {
      item.classList.remove('rating__icon--half', 'rating__icon--on');
      item.classList.toggle('rating__icon--hover', this.#active(Number(item.dataset.value), value));
    });
  }

  #onClick(event) {
    const value = Number(event.target.dataset.value);

    if (value) this.#select(value);
  }

  #onHover(event) {
    const value = Number(event.target.dataset.value);

    if (value) this.#hover(value);
  }

  #paint(value) {
    this.icons.forEach((item) => {
      const position = Number(item.dataset.value);

      item.classList.remove('rating__icon--hover');
      item.classList.toggle('rating__icon--on', this.#active(position, value));
      item.classList.toggle('rating__icon--half', !this.singleValue && this.readonlyValue && position - value > 0 && position - value < 1);
    });
  }

  #select(value) {
    value === this.scoreValue ? this.cancel() : this.#store(value);
  }

  #store(value) {
    this.scoreValue = value;
    this.element.dataset.score = value || '';

    this.#paint(value);

    if (this.scoreField) this.scoreField.value = value;

    this.dispatch('change', { detail: { value } });
  }
}
